import classNames from 'classnames'
import { h, JSX } from 'preact'

import { Button, ButtonProps } from '../../components/button/button'
import { Textfield, TextfieldProps } from '../../components/forms/textfield/textfield'
import { Loader } from '../../components/loader/loader'
import { PaymentError, type PaymentErrorProps } from '../../components/payment-error/payment-error'
import type { PluginTheme } from '../../types'
import { PaymentSection, PaymentSectionProps } from '../checkout/payment-section'

export interface GiftCardProps {
    theme: PluginTheme
    isLoading?: boolean
    error?: PaymentErrorProps
    title: string
    amountPresets: {
        text: string
        buttons: ButtonProps[]
    }
    showAmountPresetButtons: boolean
    customAmount: {
        text: string
        input: TextfieldProps
    }
    note: string
    email: {
        input: TextfieldProps
        note: string
    }
    submit: ButtonProps
    paymentSection?: PaymentSectionProps
}

export const GiftCard = (props: GiftCardProps): JSX.Element => (
    <div className={classNames('h-container', 'gift-card', `h-theme-${props.theme}`)}>
        <Loader isHidden={!props.isLoading} />
        <div className={classNames('gift-card__contents', props.isLoading && 'is-loading')}>
            {props.error && <PaymentError class="gift-card__payment-error" {...props.error} />}
            <h2 className="gift-card__title">{props.title}</h2>
            {props.showAmountPresetButtons && (
                <div className="gift-card__presets">
                    <div>{props.amountPresets.text}</div>
                    <div className="gift-card__preset-buttons">
                        {props.amountPresets.buttons.map((button, index) => (
                            <Button key={index} {...button} />
                        ))}
                    </div>
                </div>
            )}
            <div className="gift-card__custom-amount">
                <div>{props.customAmount.text}</div>
                <div className="gift-card__custom-amount-input-container">
                    <Textfield {...props.customAmount.input} /> €
                </div>
            </div>
            <div className="gift-card__note">{props.note}</div>
            <div className="gift-card__email">
                <div className="gift-card__email-input-container">
                    <Textfield {...props.email.input} />
                </div>
                <div className="gift-card__email-note">{props.email.note}</div>
            </div>
            <div className="gift-card__payment-section">
                {props.paymentSection && <PaymentSection {...props.paymentSection} />}
            </div>
            <div className="gift-card__submit">
                <Button {...props.submit} />
            </div>
        </div>
    </div>
)
